import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { isWeb } from 'smoothie';

import type { ContainerComponent } from '../../common/types/Common';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 10000, // 10 seconds
        },
    },
});

const DataFetchingProvider: ContainerComponent = ({ children }) => {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
            {isWeb ? <ReactQueryDevtools initialIsOpen={false} /> : null}
        </QueryClientProvider>
    );
};

export default DataFetchingProvider;
